'use client';

import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '@/styles/App.css';
import { Container } from 'react-bootstrap';
import Navbar from '@/components/Navbar/Navbar';
import Footer from '@/components/Footer/Footer';
import PromoCodeBanner from '@/components/PromoCodeBanner/PromoCodeBanner';

// export const metadata = {
// 	title: 'Stock Agent',
// 	description: 'Stock Agent is a web app that helps you manage your Amazon FBA business.',
// 	//image: 'https://etriever.com/EtrieverLogo.png',
// 	//url: 'https://etriever.com',
// };

export default function RootLayout({
	children,
}) {
	return (
		<Container fluid>
			<PromoCodeBanner />
			<Navbar />
			{children}
			<Footer />
		</Container>
	);
}
